const netcoreApiConfig = {
    mode: 'production',
    api: {
        baseUrl: 'https://search.unbxd.io/',
        recsBaseUrl: 'https://recommendations.unbxd.io/v2.0/',
    },
    allowedFilters: [],
    filterNameMapping: {
        v_size: 'Size',
        Color: 'Colors',
        Price: 'Price',
    },
    suggestionDoctypes: [
        'PROMOTED_SUGGESTION',
        'TOP_SEARCH_QUERIES',
        'KEYWORD_SUGGESTION',
    ],
    maxSuggestions: 10,
};

const netcoreDomain = netcoreApiConfig.api.baseUrl;
const recsBaseUrl = netcoreApiConfig.api.recsBaseUrl;
const allowedFilters = netcoreApiConfig.allowedFilters;
const suggestionDoctypes = netcoreApiConfig.suggestionDoctypes;
const maxSuggestions = netcoreApiConfig.maxSuggestions;

function getOS(userAgent) {
    let osName = 'windows';
    if (userAgent?.indexOf('Mac') != -1 || userAgent?.indexOf('like Mac') != -1) {
        osName = 'ios';
    }
    if (userAgent?.indexOf('Android') != -1) {
        osName = 'android';
    }
    return osName;
}

function detectDeviceType(pUserAgent) {
    const userAgent = pUserAgent ? pUserAgent.toLowerCase() : '';
    if (
        userAgent.match(/mobile|android|iphone|ipad|ipod|blackberry|windows phone/i)
    ) {
        return 'mobile';
    } else if (userAgent.match(/tablet|ipad/i)) {
        return 'tablet';
    } else {
        return 'desktop';
    }
}

function addUnbxdHeaders(headers, params) {
    console.log('addUnbxdHeaders :: ', params?.userAgent);
    const userId = params?.unbxdUserId ? params?.unbxdUserId : '';
    if (userId) {
    headers['unbxd-user-id'] = userId;
    }
    const deviceType = detectDeviceType(params?.userAgent);

    const os = getOS(params?.userAgent);
    headers['unbxd-device-type'] = JSON.stringify({
        type: deviceType,
        os,
        source: 'browser',
    });

    return headers;
}

async function getAutosuggestResults(params) {
  console.log('getAutosuggestResults...');
  const limit = params?.limit ? params.limit : 6;
  const page = params?.page;
  const searchUrl =
    netcoreDomain + params.apiKey + '/' + params.siteKey + '/autosuggest';
  let apiUrl =
    searchUrl +
    '?q=' +
    decodeURIComponent(params?.q) +
    '&topQueries.count=10&promotedSuggestion.count=2&keywordSuggestions.count=10' +
    '&inFields.count=0&popularProducts.count=' +
    limit +
    '&popularProducts.filter=availability:"true"&popularProducts.fields=title,imageUrl,price,productUrl,doctype&variants.count=0&promotion=true';

  let headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
  };
  headers = addUnbxdHeaders(headers, params);

  apiUrl = apiUrl.replaceAll('"', '%22').replaceAll("'", '%27');
  console.log('getAutosuggestResults encoded apiUrl :: ', apiUrl);
  const searchResult = await fetch(apiUrl, {
    method: 'GET',
    headers,
  });
  // console.log('searchResult :: ', searchResult);
  if (searchResult.ok) {
    let netcoreSearchResultJson = await searchResult.json();
    netcoreSearchResultJson['page'] = page ? page : 1;
    const total_products = parseInt(
      netcoreSearchResultJson?.response?.numberOfProducts || 0,
    );
    console.log('total_products :: ', total_products);
    if (netcoreSearchResultJson?.response?.products?.length > 0) {
      netcoreSearchResultJson.response['suggestions'] = {};
      netcoreSearchResultJson.response['product_suggestions'] = [];
      suggestionDoctypes.forEach((doctype) => {
        netcoreSearchResultJson.response['suggestions'][doctype] = [];
      });
      netcoreSearchResultJson?.response?.products?.forEach((product) => {
        if (suggestionDoctypes.includes(product.doctype)) {
          netcoreSearchResultJson?.response['suggestions'][
            product.doctype
          ].push(product);
        } else if (product.doctype === 'POPULAR_PRODUCTS') {
          netcoreSearchResultJson.response['product_suggestions'].push(product);
        }
      });
      let suggestion_count = 0;
      suggestionDoctypes.forEach((doctype) => {
        if (
          netcoreSearchResultJson?.response?.suggestions[doctype] &&
          netcoreSearchResultJson?.response?.suggestions[doctype].length > 0
        ) {
          suggestion_count +=
            netcoreSearchResultJson?.response?.suggestions[doctype].length;
          if (suggestion_count > maxSuggestions) {
            netcoreSearchResultJson.response['suggestions'][doctype] =
              netcoreSearchResultJson?.response?.suggestions[doctype].slice(
                0,
                maxSuggestions -
                  (suggestion_count -
                    netcoreSearchResultJson?.response?.suggestions[doctype]
                      .length),
              );
          }
        }
      });
    }
    delete netcoreSearchResultJson.response.products;
    netcoreSearchResultJson['nbPages'] =
      total_products % limit === 0
        ? Math.floor(total_products / limit)
        : Math.floor(total_products / limit) + 1;
    // console.log('netcoreSearchResultJson :: ', netcoreSearchResultJson);
    return netcoreSearchResultJson;
  } else {
    const errorResponse = await searchResult.text();
    console.error('error in getAutosuggestResults searchResult :: ', errorResponse);
  }
  return {};
}

const initialSearchResp = {
    response: null,
    suggestions: null,
    suggestion_results: {},
};

function getCookie(name) {
  const cookieString = document.cookie;
  const cookies = cookieString.split('; '); // Split into individual cookie strings

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const [cookieName, cookieValue] = cookie.split('='); // Split into name and value

    if (cookieName === name) {
      return decodeURIComponent(cookieValue); // Decode the value in case of special characters
    }
  }
  return null; // Return null if the cookie is not found
}

function toSentenceCase(sentence) {
  if (!sentence) {
    return '';
  }
  return sentence
    .toLowerCase()
    .split(' ')
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}

function generateSuggestionsHtmlByType(suggestionType, suggestionArr) {
    let suggestionsByType = '';
    if (searchResponse?.suggestions?.[suggestionType].length > 0) {
	  searchResponse.suggestions[suggestionType].forEach((suggestion, index) => {
		  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/mouse-events-have-key-events, jsx-a11y/no-static-element-interactions
		  let className = activeSuggestion === suggestion.autosuggest ? 'text-[#A9A9A9] cursor-pointer' : '';
          if (suggestionArr?.length >= 5) {
            className = className + ' display_none md:display_block';
          }
          suggestionArr.push(`<div
			class="${className} suggestion_item cursor-pointer"
			onclick="onSuggestionClick('${suggestion.autosuggest}')"
			onMouseOver="handleQuery('${suggestion.autosuggest}', 'suggestion')"
			style="font-size: 14px; line-height: 18px; padding: 0; padding-bottom: 8px"
			data-unxAsType="${suggestionType}"
			data-unxAsSugg="${suggestion.autosuggest}"
			data-unxAsPrank="${index}"
		  >
			${suggestion.autosuggest}
		  </div>`);
        }
	  );
    //   return suggestionsByType.join('');
    }
    // return suggestionsByType;
}

function viewAllLinkMobileHtml() {
    if (searchResponse?.response?.length > 0) {
        return `<div class="p-4 pt-2 text-center block md:hidden">
            <a class="text-center text-xl" variant="primary">
                <Input
                type="submit"
                class="underline cursor-pointer underline-offset-[2.5px]"
                value="View All"
                />
            </a>
        </div>`;
    } 
    return '';
}

function viewAllLinkDesktopHtml() {
    if (searchResponse?.response?.length > 0) {
        return `<div class="p-4 pt-2 text-center hidden md:block">
            <a class="text-center text-xl" variant="primary">
                <Input
                type="submit"
                class="underline cursor-pointer underline-offset-[2.5px]"
                value="View All"
                />
            </a>
        </div>`;
    }
    return '';
}

function generateProductHtml(product, index) {
    return `<a href="${product.productUrl}"
        title="${product.title}"
        key="${product.productUrl}"
        class="group relative w-full overflow-hidden p-2 px-2 sm:px-3 lg:px-4 border-black"
        data-unxAsType="POPULAR_PRODUCTS"
        data-unxAsSugg="${product.title}"
        data-unxAsPrank="${index}"
        data-unxAsPid="${product.uniqueId}"
    >
        <img
            src="${product?.imageUrl?.[0]}"
            height="100%"
            width="100%"
            alt="${product.title}"
        />

        <div class="mt-4">
        <p class="font-medium leading-tight text-ellipsis overflow-hidden md:max-w-[20vw] xs:max-w-full whitespace-nowrap">
            ${product.title}
        </p>
        <p class="body-small-light leading-tight">
            ${product.price}
        </p>
        </div>
    </a>`;
}
function generateSuggestedProductsHtml() {
    const productsArr = [];
    // productsArr.push(viewAllLinkMobileHtml());
    const productHtmlArr = searchResponse.response.slice(0, 4).map((product, index) => {
        return generateProductHtml(product, index);
    });
    if (productHtmlArr?.length) {
        productsArr.push('<div style="display: grid;" class="bg-[#FCFCF5]">');
        productsArr.push(productHtmlArr.join(''));
        productsArr.push('</div>');
    }
    // productsArr.push(viewAllLinkDesktopHtml());
    return productsArr.join('');    
}

function generateSuggestionsHtml() {
    const suggestionArr = [];
    for (let suggestionType of netcoreApiConfig?.suggestionDoctypes) {
        generateSuggestionsHtmlByType(suggestionType, suggestionArr);
        // suggestionArr.push(suggestionsByType);    
    }
    // const viewAllLinkMobile = viewAllLinkMobileHtml();
    const suggestionsHtml = suggestionArr.join('');
    return `<div
        style="padding: 0 0 10px; font-weight: 600; font-size: 16px"
        >
        Suggestions
        </div>
        ${suggestionsHtml}`;
}

async function getAutosuggestResult(searchTerm, type) {
    const unbxdUserId = getCookie("unbxd.userId");
    const userType = getCookie('unbxd.visit');
    const netcoreAPIParams = {
        apiKey: "d81b3759fd6d2a851f3915f35feb6c67",
        siteKey: "ss-unbxd-gus-prod-Nyco32261737705692",
        q: searchTerm,
        unbxdUserId,
        userAgent: navigator.userAgent,
        limit: 6,
        type: 'autosuggest',
    };

    const netcoreResult =
    type === 'main'
    ? await getAutosuggestResults(netcoreAPIParams)
    : await getSearchResults(netcoreAPIParams);
    if (type !== 'main') {
        const products = netcoreResult?.response?.products?.map((hit) => {
            if (hit?.relevantDocument === 'variant') {
                const v_images = hit?.variants?.[0]?.v_images?.filter(
                (v_img) => !v_img?.includes('_sw'),
                );
                if (v_images && v_images.length > 0) {
                hit.imageUrl = v_images.toReversed();
                }
            }
            return hit;
        });
    }
//   const response = await fetch('/api/autosuggest', {
//     preload: true,
//     method: 'POST',
//     headers: {
//     'Content-Type': 'application/json',
//     },
//     body: JSON.stringify({
//     searchQuery: encodeURIComponent(searchTerm),
//     type,
//     }),
//   });

//   const responseJson = await response.json();
  return netcoreResult;
}

let searchKeyword;
let activeSuggestion;
let searchResponse = initialSearchResp;
function showSearchInput() {
    const searchQueryInput = document.querySelector('#searchQuery');
    searchQueryInput.classList.remove('hidden');
    const searchCloseButton = document.querySelector('.close-icon-container .closeButton');
    searchCloseButton.addEventListener('click', () => {
        searchQueryInput.querySelector('input').value = '';
        searchQueryInput.classList.add('hidden');
        handleQuery('', 'main');
    })
}
document.addEventListener("DOMContentLoaded", () => {
    const searchQueryInput = document.querySelector('#searchQuery input');
    searchQueryInput.addEventListener('input', (event) => {
        console.log('searchQueryInput clicked', event.target.value);
        handleQuery(event.target.value, 'main');
    });
    const searchForm = document.querySelector('#searchQuery #search_form');
    searchForm.addEventListener('submit', (event) => {
        event.preventDefault();
        onSubmit(event, 'main');
    });
    const searchBtn = document.querySelector('#searchQuery #searchBtn');
    searchBtn.addEventListener('click', (event) => {
        event.preventDefault();
        if (searchKeyword && searchKeyword.trim()) {
            searchForm.submit();
        }
    });    
});
async function handleQuery(query, type) {
    searchType = type;
    if (type === 'main') {
        searchKeyword = query;
        activeSuggestion = '';
    } else {
        activeSuggestion = query;
    }
    if (query && query.trim().length >= 3) {
        const encodedQuery = encodeURIComponent(query);
        let suggestions = searchResponse.suggestions;
        let responseJson = null;
        if (encodedQuery in searchResponse?.suggestion_results) {
            responseJson = searchResponse?.suggestion_results?.[encodedQuery];
        } else {
            const autosuggestResults = await getAutosuggestResult(query, type);
            if (type === 'main') {
                responseJson = autosuggestResults?.response?.product_suggestions;
                suggestions = autosuggestResults?.response?.suggestions;
                if (suggestions) {
                    Object.keys(suggestions)?.forEach((key) => {
                        const suggestionArr = suggestions?.[key];
                        if (suggestionArr && suggestionArr?.length) {
                            suggestionArr.forEach((suggestion) => {
                                suggestion.autosuggest = toSentenceCase(
                                suggestion.autosuggest,
                                );
                            });
                        }
                    });
                }
            } else {
                responseJson = autosuggestResults?.response?.products;
            }
        }

        let suggestion_products = searchResponse.suggestion_results;
        if (
            type !== 'main' &&
            !suggestion_products.hasOwnProperty(encodedQuery)
        ) {
            suggestion_products[encodedQuery] = responseJson;
        }
        searchResponse = {
            response: responseJson,
            suggestions,
            suggestion_results: {...suggestion_products},
        };
    } else if (type === 'main') {
        // searchResponse = {
        //     ...initialSearchResp,
        //     suggestion_results: searchResponse.suggestion_results,
        // };
        searchResponse = initialSearchResp;
    }
    const autosuggestResultContainer = document.getElementById("autosuggest_result");
    const suggestionProductsContainer = document.getElementById("suggestion_products_container");
    if (searchResponse?.response?.length > 0) {
        if (type === 'main') {
            const suggestionContainer = document.getElementById("suggestion_container");
            const suggestionHtml = generateSuggestionsHtml();
            suggestionContainer.innerHTML = suggestionHtml;
            suggestionContainer.querySelectorAll('.suggestion_item').forEach(item => {
                const autosuggest = item.dataset.unxassugg;
                if (autosuggest) {
                    item.addEventListener('mouseover', () => {
                        suggestionContainer.querySelectorAll('.suggestion_item').forEach(itm => itm.classList.remove('text-[#A9A9A9]'));
                        item.classList.add('text-[#A9A9A9]');
                    });
                }
            });
        }

        const productsHtml = generateSuggestedProductsHtml();
        suggestionProductsContainer.innerHTML = productsHtml;
        autosuggestResultContainer.classList.remove("hidden");

        const viewAllLink = document.getElementById("view_all_link");
        viewAllLink.addEventListener("click", () => {
            window.location.href = `/search?q=${encodeURIComponent(activeSuggestion || searchKeyword)}`
        });        
    } else {
        autosuggestResultContainer.classList.add("hidden");
    }
}

async function onSuggestionClick(suggestion) {
    window.location.href = `/search?q=${encodeURIComponent(suggestion)}`;
};

const triggerSearchEvent = (searchQuery, type) => {
    const payload = {
        query: encodeURIComponent(searchQuery),
    };
    if (type) {
        payload['autosuggest_type'] = type;
    }
    if (
        typeof window !== 'undefined' &&
        window?.Unbxd &&
        typeof window?.Unbxd?.track === 'function'
    ) {
        console.log('calling search event with payload :: ', payload);
        window?.Unbxd?.track('search', payload);
    } else {
        console.error('unbxdAnalytics.js is not loaded!');
    }
};

const onSubmit = (event) => {
    event.preventDefault();
    if (searchKeyword && searchKeyword.length) {
        triggerSearchEvent(searchKeyword, '');
        window.location.href = `/search?q=${encodeURIComponent(searchKeyword)}`;
    }
};

console.log('searchResponse', searchResponse);

const promotedSuggestionsCount =
    searchResponse?.suggestions?.['PROMOTED_SUGGESTION']?.length;
const topSearchQuesriesCount =
    searchResponse?.suggestions?.['TOP_SEARCH_QUERIES']?.length;
const keywordSuggestionsCount =
    searchResponse?.suggestions?.['KEYWORD_SUGGESTION']?.length;